var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.searchResult.items,"loading":_vm.loading,"label":_vm.label,"placeholder":_vm.placeholder,"clearable":_vm.clearable,"item-text":"name","item-value":"id"},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }